import { SaveAndLoadModalAction } from '@/enums/portfolio-optimization.enum'
import { useEffect, useState } from 'react'

export const useSaveLoadModal = (key: string) => {
  const [screenConstraintName, setScreenConstraintName] = useState<string>('')
  const [screenConstraintNameList, setScreenConstraintNameList] = useState<
    string[]
  >([])
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState<{
    mode: SaveAndLoadModalAction
    isOpen: boolean
  }>({
    mode: SaveAndLoadModalAction.SAVE,
    isOpen: false,
  })

  const handleModalOpen = (mode: SaveAndLoadModalAction) =>
    setOpenModal({ mode, isOpen: true })
  const handleModalClose = () =>
    setOpenModal({ mode: openModal.mode, isOpen: false })

  const generateNormalizedKey = (name: string) => {
    return name
      .replace(/\s+/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toLowerCase()
  }

  const handleSave = (storedConstraints: any, gridData: any) => {
    if (screenConstraintName) {
      const normalizedKey = generateNormalizedKey(screenConstraintName)
      storedConstraints[normalizedKey] = {
        label: screenConstraintName,
        constraints: gridData, // Store the grid data here
      }
      localStorage.setItem(key, JSON.stringify(storedConstraints))
      updateScreenConstraintNameList(storedConstraints) // Update the list after saving
    } else {
      console.error('Constraint name cannot be empty.')
    }
  }

  const handleLoad = (storedConstraints: any) => {
    if (screenConstraintName) {
      const normalizedKey = generateNormalizedKey(screenConstraintName)
      return storedConstraints[normalizedKey]?.constraints
    } else {
      console.error('Constraint name cannot be empty.')
    }
    return null
  }

  const updateScreenConstraintNameList = (storedConstraints: any) => {
    const names = Object.values(storedConstraints).map(
      (constraint: any) => constraint.label,
    )
    setScreenConstraintNameList(names)
  }

  useEffect(() => {
    const storedConstraints = JSON.parse(localStorage.getItem(key) || '{}')
    updateScreenConstraintNameList(storedConstraints)
  }, [key])

  return {
    screenConstraintName,
    screenConstraintNameList,
    updateScreenConstraintNameList,
    loading,
    openModal,
    setScreenConstraintName,
    handleModalOpen,
    handleModalClose,
    handleSave,
    handleLoad,
  }
}
